let scrollPosition = 0;

function disableBodyScroll() {
  // Save current scroll position
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  
  // Add fixed position to the body and set top offset to negative scroll position
  document.body.classList.add('modal-open');
  document.body.style.top = `-${scrollPosition}px`;
}

function enableBodyScroll() {
  document.body.classList.remove('modal-open');
  document.body.style.top = '';
  window.scrollTo(0, scrollPosition);
}

function ingredientListRevealAll() {
  const ingredientListItem = document.querySelectorAll('.js-ingredients__item');

  // Curent active
  let activeIngredientElement = document.querySelector('.js-ingredients__item.active-ingredient'),
      activeIngredientContent = document.querySelector('.js-ingredient__content.active-ingredient');

  const popupWrapper = document.querySelector('.ingredient-popup'),
        popupContainer = document.querySelector('.ingredient-popup .popup-modal__content-info'),
        closeButton = document.querySelector('#ModalClose');

  let isMobile = false;

  if (window.innerWidth <= 989) {
    isMobile = true;
  }
  
  ingredientListItem.forEach((ingredient) => {
    if (isMobile) {
      ingredient.addEventListener('click', (e) => {
        e.preventDefault();

        let ingredientContent = ingredient.querySelector('.js-ingredient__content').cloneNode(true);

        popupContainer.innerHTML = '';

        scrollPosition = window.pageYOffset || document.documentElement.scrollTop;    
    
        // Append ingredient content to popup
        popupContainer.appendChild(ingredientContent);
    
        // Append popup to body
        popupWrapper.setAttribute('aria-hidden', false);
        popupWrapper.setAttribute('open', '');

        disableBodyScroll();
      });
    } else {
      ingredient.addEventListener('mouseover', (e) => {
        // Remove current active
        if (activeIngredientElement && activeIngredientElement !== e.target) {
          activeIngredientElement.classList.remove('active-ingredient');
          activeIngredientContent.classList.remove('active-ingredient');
        }
  
        // Assign new current active
        let ingredientElement = e.target.closest('.js-ingredients__item');
        let ingredientContent = ingredientElement.querySelector('.js-ingredient__content');
  
        activeIngredientElement = ingredientElement;
        activeIngredientContent = ingredientContent;
        
        ingredientElement.classList.add('active-ingredient');
        ingredientContent.classList.add('active-ingredient');
      });
    }
  });

  // Close popup when the close button is clicked
  closeButton.addEventListener('click', () => {
    popupWrapper.setAttribute('aria-hidden', true);
    popupWrapper.removeAttribute('open');
    enableBodyScroll();
  });

  // Close popup when clicking outside the modal
  window.addEventListener('click', (e) => {
    if (e.target === popupWrapper) {
      popupWrapper.setAttribute('aria-hidden', true);
      popupWrapper.removeAttribute('open');
      enableBodyScroll();
    }
  });
}

ingredientListRevealAll();
